import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { reduxForm } from 'redux-form';
import { getClassName } from '../../utils/forms';
import { openDialog, closeDialog } from '../../actions/dialog';
import { updateUserAccount, listUserTypes, listUsers } from '../../actions/user';
import { setUserToEdit, storeWithExpiration, toIdString } from '../../utils/common';
import UserEdit from './UserEdit';
import {
  PROVIDER_ADMIN,
  SUPER_ADMIN,
  VALID_EMAIL_REGEX,
} from '../../config/app_config';

const FORM_ID = 'editUserForm';

export class UserEditContainer extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isUser: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    isProviderAdmin: PropTypes.bool.isRequired,
    listUserTypesAction: PropTypes.func.isRequired,
    listUsersAction: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    updateUserAccountAction: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    users: PropTypes.object.isRequired,
    userToEdit: PropTypes.object.isRequired,
    userTypes: PropTypes.object.isRequired,
  };

  componentWillMount = () => {
    const { accountId, userToEdit, listUserTypesAction, listUsersAction } = this.props;
    const token = storeWithExpiration.get('token');
    listUserTypesAction(userToEdit.accountId, token);
    listUsersAction(accountId, token);
  };

  performEditUser = params => {
    const { user, isUser, userToEdit, updateUserAccountAction } = this.props;
    const token = storeWithExpiration.get('token');

    const userData = {
      id: userToEdit.id,
      email: userToEdit.email,
      userTypeId: parseInt(params.accessLevel, 10) || userToEdit.userTypeId,
      firstName: params.firstName,
      lastName: params.lastName,
      phone: params.phoneNumber,
      accountId: userToEdit.accountId,
      status: 1,
      isPrimary: params.isPrimary,
      portalAccountId: null,
      createdBy: userToEdit.createdBy,
      updatedBy: user.id,
      updatedOn: new Date().toISOString(),
    };

    updateUserAccountAction(userData, isUser, token).then(() => {
      browserHistory.goBack();
    });
  };

  renderUserTypes = userType => (
    <option key={userType.id} value={userType.id}>
      {userType.description}
    </option>
  );

  renderSelect = ({ input, label, userTypes, meta: { touched, error } }) => (
    <div className={getClassName(touched, error)}>
      <label htmlFor={toIdString(label)} className="form-control-label">
        {label} {touched && error && <span className="error">{error}</span>}
      </label>
      <select {...input} id={toIdString(label)} className="form-control">
        {userTypes.size === 0 ? null : userTypes.valueSeq().map(this.renderUserTypes)}
      </select>
    </div>
  );

  renderCheckbox = ({ input, type, label, meta: { touched, error } }) => (
    <div className={getClassName(touched, error)}>
      <label htmlFor={toIdString(label)} className="form-control-label">
        {label} {touched && error && <span className="error">| {error}</span>}
      </label>
      <br />
      <input {...input} id={toIdString(label)} type={type} />
    </div>
  );

  render() {
    const {
      handleSubmit,
      invalid,
      isSuperAdmin,
      isProviderAdmin,
      isUser,
      submitting,
      userTypes,
      users,
    } = this.props;

    return users.size > 0 ? (
      <UserEdit
        handleSubmit={handleSubmit}
        submitFunction={this.performEditUser}
        invalid={invalid}
        isSuperAdmin={isSuperAdmin}
        isProviderAdmin={isProviderAdmin}
        isUser={isUser}
        renderCheckbox={this.renderCheckbox}
        renderSelect={this.renderSelect}
        submitting={submitting}
        userTypes={userTypes}
      />
    ) : null;
  }
}

const validate = values => {
  const errors = {};
  if (!values.firstName || values.firstName === '') {
    errors.firstName = 'Required';
  }
  if (!values.lastName || values.lastName === '') {
    errors.lastName = 'Required';
  }
  if (!values.email || values.email === '') {
    errors.email = 'Required';
  } else if (!VALID_EMAIL_REGEX.test(values.email)) {
    errors.email = 'Invalid User Email';
  }
  if (!values.phoneNumber || values.phoneNumber === '') {
    errors.phoneNumber = 'Required';
  }
  return errors;
};

const UserEditContainerRF = reduxForm({
  form: FORM_ID,
  validate,
  enableReinitialize: true,
})(UserEditContainer);

function mapStateToProps(state, ownProps) {
  const { user, userList } = state;
  const { params } = ownProps;
  const accountId = parseInt(params.accountId, 10);
  const users = userList.get('users');
  const userTypes = userList.get('userTypes');
  const isUser = parseInt(params.userId, 10) === user.id;
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  const isProviderAdmin = user.get('userTypeId') === PROVIDER_ADMIN;
  const userToEdit =
    users.size > 0 ? setUserToEdit(users, user, parseInt(params.userId, 10)) : user;
  const initialValues = {
    firstName: userToEdit.firstName,
    lastName: userToEdit.lastName,
    accessLevel: userToEdit.userTypeId,
    phoneNumber: userToEdit.phone,
    isPrimary: userToEdit.isPrimary,
  };
  return {
    accountId,
    initialValues,
    isUser,
    isSuperAdmin,
    isProviderAdmin,
    userToEdit,
    user,
    users,
    userTypes,
  };
}

export default connect(mapStateToProps, {
  openDialogAction: openDialog,
  closeDialogAction: closeDialog,
  updateUserAccountAction: updateUserAccount,
  listUserTypesAction: listUserTypes,
  listUsersAction: listUsers,
})(UserEditContainerRF);
